import {IProductPriceObject} from 'coreClasses/product/IProduct';
import ManagerRepository from 'coreClasses/ManagerRepository';
import {IEventData} from 'coreClasses/events/IEvents';
import VariantModel from 'coreClasses/product/VariantModel';
import EventModel from '../EventModel';

/**
 * Represents ProductAddToWishlistEventModel
 */
export default class ProductAddToWishlistEventModel extends EventModel {
	public productName: string;
	public productPrice: IProductPriceObject;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		const product: VariantModel = data.product;

		this.productName = product?.getName();
		this.productPrice = product?.getVariationGroup()?.getPriceModel()?.getMinPrice();
	}
}
